export default __webpack_public_path__ + "static/media/node.2a129363.jpg";